import { render, staticRenderFns } from "./FooterBase.vue?vue&type=template&id=2e582874&scoped=true"
import script from "./FooterBase.vue?vue&type=script&lang=js"
export * from "./FooterBase.vue?vue&type=script&lang=js"
import style0 from "./FooterBase.vue?vue&type=style&index=0&id=2e582874&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e582874",
  null
  
)

export default component.exports